import { Injectable } from '@angular/core'

import { AlertComponent } from './dialogs/alert/alert.component'
import { WarningComponent } from './dialogs/warning/warning.component'
import { ConfirmComponent } from './dialogs/confirm/confirm.component'
import { GenericComponent } from './dialogs/generic/generic.component'
import { LoadingComponent } from './dialogs/loading/loading.component'

import { InjectorService } from '../../services/injector.service'
import {ConfirmRevertComponent} from './dialogs/confirm-revert/confirm-revert.component';

@Injectable()
export class DialogsService {

  private get alertRef () {
    return this.injector.getComponent<AlertComponent>('DIALOG.ALERT', AlertComponent)
  }

  private get warningRef () {
    return this.injector.getComponent<WarningComponent>('DIALOG.WARNING', WarningComponent)
  }

  private get confirmationRef () {
    return this.injector.getComponent<ConfirmComponent>('DIALOG.CONFIRM', ConfirmComponent)
  }

  private get confirmationRevertRef () {
    return this.injector.getComponent<ConfirmRevertComponent>('DIALOG.CONFIRM_REVERT', ConfirmRevertComponent)
  }

  private get genericRef () {
    return this.injector.getComponent<GenericComponent>('DIALOG.GENERIC', GenericComponent)
  }

  private get loadingRef () {
    return this.injector.getComponent<LoadingComponent>('DIALOG.LOADING', LoadingComponent)
  }

  constructor (
    private injector: InjectorService
  ) { }

  error (message: string) {
    const dialog = this.alertRef
    dialog.color = 'accent'
    dialog.icon = 'wrong'
    dialog.message = message
    dialog.title = 'Error'
    return dialog.show()
  }

  warning (message: string, title: string) {
    const dialog = this.warningRef
    dialog.color = 'accent'
    dialog.icon = 'warning'
    dialog.message = message
    dialog.title = title
    return dialog.show()
  }

  warningConfig (message: string, title: string, btn: string) {
    const dialog = this.warningRef;
    dialog.color = 'accent';
    dialog.icon = 'warning';
    dialog.message = message;
    dialog.title = title;
    dialog.btn = btn;
    return dialog.show()
  }

  confirm (message: string) {
    const dialog = this.confirmationRef
    dialog.message = message
    return dialog.show()
  }

  confirmRevert (message: string) {
    const dialog = this.confirmationRevertRef
    dialog.message = message
    return dialog.show()
  }

  reConfirm (message: string) {
    const dialog = this.genericRef
    dialog.message = message
    return dialog.show()
  }

  message (message: string) {
    const dialog = this.genericRef
    dialog.message = message
    return dialog.show()
  }

  loading (color: string = '#4bbe9c') {
    const dialog = this.loadingRef
    dialog.color = color
    return dialog.show()
  }

  okConfirm(message: string) {
    const alert = this.alertRef
    alert.icon = 'ok'
    alert.message = message
    alert.color = 'accent'
    alert.title = 'Acción exitosa'
    return alert.show()
  }
  showMessage(message: string, color: string, icon: string) {
    const alert = this.alertRef
    alert.icon = icon
    alert.color = color
    alert.message = message
    return alert.show()
    }

  showMessageConfig(title: string, message: string, color: string, icon: string) {
    const alert = this.alertRef;
    alert.icon = icon;
    alert.color = color;
    alert.message = message;
      alert.title = title || 'Acción exitosa';
    return alert.show();
    }

ó}
